import {useEffect} from 'react'

const useMutedVideo = () => {
    useEffect(() => {
        const setMutedOnVideos = () => {
            document.querySelectorAll('video').forEach((video) => {
                if (!video.hasAttribute('muted')) {
                    video.setAttribute('muted', '')
                }
                video.muted = true
            })
        }

        setMutedOnVideos()

        const observer = new MutationObserver(setMutedOnVideos)
        observer.observe(document.body, {childList: true, subtree: true})

        return () => observer.disconnect()
    }, [])
}

export default useMutedVideo
